var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusTxt && _vm.statusTxt != 0)?_c('div',{staticClass:"content",class:{ green: _vm.isGreen }},[_vm._v("\n  "+_vm._s(_vm.statusTxt)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }